import PersonalizationCardImage from "./components/PersonalizationCardImage";
import PersonalizationInput from "./components/PersonalizationInput";
import PersonalizationTextarea from "./components/PersonalizationTextarea";
import {useState} from "react";
import PersonalizationCardTabPicker from "./components/PersonalizationCardTabPicker";
import PersonalizationDivider from "./components/PersonalizationDivider";

export default function PersonalizationNextTopHealthConcerns({
                                                                    getError,
                                                                    healthConcernsFormData,
                                                                    setHealthConcernsFormData,
                                                                    lifeImpactsFormData,
                                                                    setLifeImpactsFormData
}) {

    const tabs = [
        {label:'First HC', value:'first_hc'},
        {label:'Second HC', value:'second_hc'},
        {label:'Third HC', value:'third_hc'},
    ];
    const [activeTab,setActiveTab] = useState(tabs[0]);










    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap:'20px'
    }}>
        <PersonalizationCardTabPicker
            tabs={tabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
        />

        {
            activeTab?.value === tabs?.[0]?.value && <div style={{
                display: "flex",
                flexDirection: "column",
                gap: '20px'
            }}>
                <PersonalizationCardImage src={'/assets/survey_personalization_screens/next_top_3_first.png'} alt={'Welcome Screen'}/>
                <PersonalizationTextarea
                    title={'Question/Statement'}
                    value={healthConcernsFormData?.nextQuestion1Title}
                    setValue={(value) => setHealthConcernsFormData({nextQuestion1Title:value})}
                    errorMessage={getError('healthConcerns','nextQuestion1Title')}
                />
            </div>
        }

        {
            activeTab?.value === tabs?.[1]?.value && <div style={{
                display: "flex",
                flexDirection: "column",
                gap: '20px'
            }}>
                <PersonalizationCardImage src={'/assets/survey_personalization_screens/next_top_3_second.png'} alt={'Welcome Screen'}/>
                <PersonalizationTextarea
                    title={'Question/Statement'}
                    value={healthConcernsFormData?.nextQuestion2Title}
                    setValue={(value) => setHealthConcernsFormData({nextQuestion2Title:value})}
                    errorMessage={getError('healthConcerns','nextQuestion2Title')}
                />
            </div>
        }

        {
            activeTab?.value === tabs?.[2]?.value && <div style={{
                display: "flex",
                flexDirection: "column",
                gap: '20px'
            }}>
                <PersonalizationCardImage src={'/assets/survey_personalization_screens/next_top_3_third.png'} alt={'Welcome Screen'}/>
                <PersonalizationTextarea
                    title={'Question/Statement'}
                    value={healthConcernsFormData?.nextQuestion3Title}
                    setValue={(value) => setHealthConcernsFormData({nextQuestion3Title:value})}
                    errorMessage={getError('healthConcerns','nextQuestion3Title')}
                />
            </div>
        }
    </div>
}
